module.exports = __webpack_public_path__ + "img/green.c70c5d93.png";